import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type ISurveySlice from './interfaces/ISurveySlice';

export const initialState: ISurveySlice = {
  surveys: [],
  surveyId: -1,
  isViewMode: false,
  surveyToken: undefined,
};

export const surveySlice = createSlice({
  name: 'survey',
  initialState,
  reducers: {
    setViewMode: (state, { payload }: PayloadAction<boolean>) => {
      state.isViewMode = payload;
    },
    setSurveyToken: (
      state,
      { payload }: PayloadAction<{ token: string, surveyType: string }>,
    ) => {
      state.surveyToken = payload;
    },
    resetState: () => initialState,
  },
});

export const {
  resetState,
  setViewMode,
  setSurveyToken,
} = surveySlice.actions;

export default surveySlice.reducer;
